import { escapeHtml } from './escapeHtml';
import { cnpj } from './cnpj';
import { cpf } from './cpf';
import { cpfOrCnpj } from './cpfOrCnpj';
import { abbreviateName } from './abbreviateName';
import { telephone } from './telephone';
import { date, datetime, momentFilter } from './moment';
import { billPaymentStatus } from './translate';
import { truncate } from './truncate';

export default {
  install(app) {
    app.config.globalProperties.$filters = {
      escapeHtml,
      cnpj,
      cpf,
      cpfOrCnpj,
      abbreviateName,
      telephone,
      date,
      datetime,
      moment: momentFilter,
      billPaymentStatus,
      truncate,
    };
  },
};
